/**
 * Don't change this to ES6. This is needed in ES5 in order to support
 * testing and correct importing in external projects.
 */
/* eslint-disable */
module.exports = Object.assign(
  {},
  require('./components/common'),
  require('./components/constants'),
  require('./components/product'),
  require('./directives')
);
